import apiService from './api.service'
export const getUserProfileApi = () => apiService.get('api/user/profiles');